<template>
  <section class="column-container">
    <div v-if="memu1Id == 'y0lm76lhgr'">
      <News></News>
    </div>
    <div v-if="memu1Id == 'y0lm76pdhn'">
      <About></About>
    </div>
    <div v-if="memu1Id == 'y0lm76m9z3'">
      <Academics></Academics>
    </div>
    <div v-else-if="memu1Id == 'y0lm76mqb0'">
      <CampusLife></CampusLife>
    </div>
    <div v-else-if="memu1Id == 'y0lm76n5u1'">
      <Admission></Admission>
    </div>
    <div v-else-if="memu1Id == 'y0lm76nibq'">
      <Scholarship></Scholarship>
    </div>
    <div v-else-if="memu1Id == 'y0lm76nzz2'">
      <Support></Support>
    </div>
    <div v-else-if="memu1Id == 'y0lm76obd6'">
      <Alumni></Alumni>
    </div>
    <div v-else-if="memu1Id == 'y0lm76oogy'">
      <AidTraining></AidTraining>
    </div>
  </section>
</template>

<script>
import { getOneMenu } from '@/api/column';

import News from '../comp/News.vue';
import About from '../comp/About.vue';
import Academics from '../comp/Academics.vue';
import CampusLife from '../comp/CampusLife.vue';
import Admission from '../comp/Admission.vue';
import Scholarship from '../comp/Scholarship.vue';
import Support from '../comp/Support.vue';
import Alumni from '../comp/Alumni.vue';
import AidTraining from '../comp/AidTraining.vue';


import CardGrid from './components/CardGrid';
import PosterModule from './components/PosterModule';
import ColumnGrayGrid from './components/ColumnGrayGrid';
import ArticleGrayGrid from './components/ArticleGrayGrid';
import ArticleGrayPanel from './components/ArticleGrayPanel';
import ArticleWhitePanel from './components/ArticleWhitePanel';
import SanJiaoXing from './components/Sanjiaoxing';
import QA from './components/QA';
import PosterGrayGrid from './components/PosterGrayGrid';
import VideoModule from './components/VideoModule';

export default {
  components: {
    News,
    About,
    Academics,
    CampusLife,
    Admission,
    Scholarship,
    Support,
    Alumni,
    AidTraining,

    QA,
    VideoModule,
    CardGrid,
    PosterModule,
    ColumnGrayGrid,
    ArticleGrayGrid,
    ArticleGrayPanel,
    ArticleWhitePanel,
    SanJiaoXing,
    PosterGrayGrid
  },
  data() {
    return {
      memu1Id: undefined,
      data: {
        list: []
      },
      swiper: '',
      list: [],
      loaded: true,
      pageNumber: 1,
      pageSize: 8,
      totalRow: 0
    }
  },
  created() {
    this.memu1Id = this.$route.query.memu1Id;
    this.data = { list: [] }
      this.getPageData()
  },
  watch: {
    '$route.query.memu1Id': function (val) {
      this.memu1Id = val;
      this.pageNumber = 1;
      this.pageSize = 8;
      this.list = [];
      this.getPageData()
    }
  },
  methods: {
    getPageData() {
      this.loaded = false;
      // getOneMenu(this.memu1Id).then(res => {
      //   this.data = res.data;
      //   this.swiper = this.data.swiper;
      //   this.loaded = true
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variable.scss';
@import '../home/index.scss';

.column-container {
  padding-top: 145.75px;
  .swiper {
    position: relative;

    img {
      display: block;
      width: 100%;
    }

    p {
      position: absolute;
      left: 50%;
      margin-left: -600px;
      bottom: 300px;
      width: 1500px;
      text-align: center;
      font-size: 48px;
      font-weight: 700;
      color: #fff;
    }
  }

  .tips {
    font-weight: 700;
    width: 1500px;
    margin: 0 auto 60px;
    font-size: 16px;

    span {
      color: #b1040e;
    }
  }
}
</style>
